import LocationIconSM from '@skyscanner/backpack-web/bpk-component-icon/sm/location';
import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';

import type { Nullable } from '@shared/types/utils';

import STYLES from './PoiDistance.module.scss';

import { FormattedDistance } from '@shared/ui/components/i18n';

const PoiDistance = ({
  linearDistance,
}: {
  linearDistance: Nullable<number>;
}) => {
  if (!linearDistance) {
    return null;
  }

  return (
    <div className={STYLES.PoiDistance__location}>
      <div className={STYLES.PoiDistance__locationIcon}>
        <LocationIconSM />
      </div>
      <BpkText
        textStyle={TEXT_STYLES.footnote}
        tagName="p"
        className={STYLES.PoiDistance__distance}
        color={TEXT_COLORS.textPrimary}
      >
        <FormattedDistance
          distanceMeters={linearDistance}
          options={{
            kmString: 'Distance_label_fromHotelKm',
            milesString: 'Distance_label_fromHotelMiles',
            // eslint-disable-next-line react/no-unstable-nested-components
            replace: (val) => (
              <span className={STYLES.PoiDistance__important}>{val}</span>
            ),
          }}
        />
      </BpkText>
    </div>
  );
};

export default PoiDistance;
